import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorFallback = () => {
  const { t } = useTranslation();
  return <Alert severity="error">{t("bots.profitChart.error")}</Alert>;
};

export default ErrorFallback;
